import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { UnsupportedBrowserComponent } from './unsupported-browser.component';

@NgModule({
  imports: [CommonModule, ModalModule.forRoot()],
  declarations: [UnsupportedBrowserComponent],
  exports: [UnsupportedBrowserComponent]
})
export class UnsupportedBrowserModule {}
